import React from "react";
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const User = props => {
  const { reports } = props;
  return (
    <React.Fragment>
      <Col xl={12}>
        <Row>
        {reports && reports.map((r,k)=>( 
          <Col lg={3} key={k}>
            <Card className="mini-stats-wid">
              <CardBody>
              <div className="d-flex flex-wrap">
                  <div className="me-3">
                    <p className="text-muted mb-2">{r.title}</p>
                    <h5 className="mb-0">{r.value}</h5>
                  </div>

                  <div className="avatar-sm ms-auto">
                    <div className={`avatar-title bg-light rounded-circle text-${r.color} font-size-20`}>
                      <i className={r.icon}></i>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          ))}          
        </Row>
      </Col>
    </React.Fragment>
  );
};

User.propTypes = {
  reports: PropTypes.any
};

export default User;
